import type { CardButtonProps } from '@jouzen/ecom-components';

import type { ArticleCardsModuleProps } from '@/app/components/ArticleCardsModule';

const common: CardButtonProps = {
  ariaLabel: 'press_read_article',
  external: true,
  color: 'slate-600',
  rel: 'noopener noreferrer',
  target: '_blank',
};

const sleepAndRestBlogs = (
  localePartialUrl: string,
): Pick<ArticleCardsModuleProps, 'articleCards' | 'articleImage'> => ({
  articleCards: [
    {
      heading: 'sleep_and_rest_cta_article_one',
      buttonProps: {
        href: `https://ouraring.com/blog${localePartialUrl}sleep-stages/`,
        ...common,
      },
    },
    {
      heading: 'sleep_and_rest_cta_article_two',
      buttonProps: {
        href: `https://ouraring.com/blog${localePartialUrl}sleeping-heart-rate/`,
        ...common,
      },
    },
    {
      heading: 'sleep_and_rest_cta_article_three',
      buttonProps: {
        href: `https://ouraring.com/blog${localePartialUrl}what-is-your-chronotype/`,
        ...common,
      },
    },
  ],
  articleImage: {
    alt: 'sleep_and_rest_cta_img_alt',
    buttonProps: {
      className: 'text-slate-600',
      external: true,
      href: `https://ouraring.com/blog${localePartialUrl}how-to-get-better-sleep/`,
      label: 'read_more',
      rel: 'noopener noreferrer',
      target: '_blank',
      variant: 'secondary-light',
    },
    heading: 'sleep_and_rest_cta_description',
    src: '/blue-sky/sleep-and-rest/sleep-and-rest-cta',
  },
});

export default sleepAndRestBlogs;
